import { Injectable } from '@angular/core';
import { UserApiService } from './user-api.service';
import { debounceTime, filter, switchMap, tap, map, shareReplay, catchError, distinctUntilChanged } from 'rxjs/operators'
import { BehaviorSubject, ReplaySubject, empty } from 'rxjs';
import { UserModel, UserNameModel } from 'shared/definition';
import { areArrayEqual } from 'shared/utils';
@Injectable({
  providedIn: 'root'
})
export class UserDelayApiService {

  pool$ = new BehaviorSubject<string[]>([]);
  users$ = new ReplaySubject<UserNameModel[]>(1);
  add(id: string | string[]) {
    const temp = [...this.pool$.value];
    if (typeof id == "string") {
      if (temp.indexOf(id) < 0) {
        temp.push(id);
        this.pool$.next(temp);
      }
    }
    else if (Array.isArray(id)) {

      id.forEach(i => {
        if (temp.indexOf(i) < 0) {
          temp.push(i)
        }
      })
      if (temp.length > this.pool$.value.length) {
        this.pool$.next(temp)
      }

    }

  }
  constructor(private api: UserApiService) {

    this.pool$.pipe(
      filter(pool => pool.length > 0),
      distinctUntilChanged((a, b) => areArrayEqual(a, b)),
      debounceTime(50),
      tap(() => this.pool$.next([])),
      switchMap(ids => this.api.getList({
        ids: ids,
        locationMatch: 'None'
      }).
        pipe(
          catchError(() => empty()),
          map(userNames => {
            ids.forEach(id => {
              if (userNames.findIndex(u => u.id == id) < 0) {
                userNames.push({
                  id: id,
                  userName: undefined,
                  realName: undefined,
                  location: undefined
                })
              }
            })
            return userNames;
          })
        )
      ),
    ).subscribe(users => this.users$.next(users));
  }


}
